import SotbitInput from '@/components/input';
import { html, css, unsafeCSS, nothing } from 'lit';
import { ref } from 'lit/directives/ref.js';
import { live } from 'lit/directives/live.js';
import styles from './textarea.scss?inline';
import { TEXTAREA } from '@/components/textarea/constants.js';
import { DEFAULT_INPUT_PROPERTIES } from '@/components/input/constants.js';

export default class SotbitTextarea extends SotbitInput {
    static styles = [
        SotbitInput.styles,
        css`
            ${unsafeCSS(styles)}
        `,
    ];

    static properties = {
        ...DEFAULT_INPUT_PROPERTIES,
        rows: { type: Number },
        resize: { type: String },
        size: { type: String },
        minLength: { type: String, attribute: 'minlength' },
        maxLength: { type: String, attribute: 'maxlength' },
    };

    get value() {
        return super.value;
    }

    set value(val) {
        super.value = val;
    }

    constructor() {
        super();
        this.rows = null;
        this.resize = null;
        this.minLength = null;
        this.maxLength = null;
    }

    render() {
        return html`
            <sotbit-textarea-style
                size="${this.size}"
                ?error="${this.error}"
                error-text="${this.errorText || nothing}"
                helper-text="${this.helperText || nothing}"
                label="${this.label || nothing}"
                resize="${this.resize || nothing}"
                ${ref(this.styleRef)}
                @change="${this._handleChange}"
                @input="${this._handleInput}"
                exportparts="outline, input-container"
            >
                <textarea
                    .value="${live(this.value)}"
                    slot="input"
                    name="${this.name || nothing}"
                    ${ref(this.inputRef)}
                    placeholder="${this.placeholder || nothing}"
                    rows="${this.rows || TEXTAREA.DEFAULT_ROWS_COUNT}"
                    minlength="${this.minLength || nothing}"
                    maxlength="${this.maxLength || nothing}"
                    ?required="${this.required}"
                    ?disabled="${this.disabled}"
                    @input="${this._handleInput}"
                    @blur="${this._handleBlur}"
                    @invalid="${this._handleInvalid}"
                    part="textarea"
                >
                </textarea>
            </sotbit-textarea-style>
        `;
    }
}
